import { useAppContext, useSafeState } from '#hooks';
import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { PlansTable } from '#users/components/plansTable.component';
import { Bundle, Destination, DestinationDetails, EsimProvider, Plan, User } from '#types';
import { dashboardApi } from '#api';

interface AssignEsimFormProps {
    user: User;
    setUser: Dispatch<SetStateAction<User>>
    setDisplayAssignEsimForm: Dispatch<SetStateAction<boolean>>
    bundles: Bundle[];
}

export const AssignEsimForm: FC<AssignEsimFormProps> = ({ user, setUser, setDisplayAssignEsimForm, bundles }) => {

    const { setApiStatus } = useAppContext();
    const [selectedPlan, setSelectedPlan] = useSafeState<Plan>({} as Plan)
    const [showConfirmation, setShowConfirmation] = useSafeState<boolean>(false)
    const [isLoading, setIsLoading] = useSafeState<boolean>(false)
    const iccids = bundles.map((b) => b.esim?.iccid).filter((iccid): iccid is string => Boolean(iccid));
    const [selectedIccid, setSelectedIccid] = useSafeState<string>('');

    const handleSubmit = async (iccid: string) => {
        try {
            setIsLoading(true)
            if (!iccid) return
            const response = await dashboardApi.assignEsim(user.email, selectedPlan.productCode, iccid, selectedPlan?.destinationName);
            setUser(response.data)
            setApiStatus({ code: response.status, message: `${selectedPlan.name} - ${selectedPlan.destinationName} has been successfully assigned to ${user.email}` })
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
            setDisplayAssignEsimForm(false)
        }
    }

    if (isLoading) {
        return <div className="lds-hourglass" />
    }

    return <div className='main-dashboard-container pd-m mt-s'>
        <h3 className='mb-m'>Generate order for {user.email}</h3>
        {
            showConfirmation ? (
                <>
                    <div className="mt-s">
                        {iccids.length === 0 ? (
                            <p className="warning">No ICCIDs available for this user.</p>
                        ) : (
                            <div className='two-rows'>
                                <div className="three-columns-expand-three mt-s">
                                    <p>Choose eSIM:</p>
                                    <select className='ml-l' value={selectedIccid} onChange={(e) => setSelectedIccid(e.target.value)}>
                                        {iccids.map((iccid) => (
                                            <option key={iccid} value={iccid}>
                                                {iccid}
                                            </option>
                                        ))}
                                    </select>
                                    <div />
                                </div>
                                <div>
                                    <div className="two-columns-expand-one mt-s" />
                                    <div className="two-columns-expand-one mt-s">
                                        <div />
                                        <div>
                                            <button onClick={() => setShowConfirmation(false)} id="esim-assign-confirmation-button" className="pd-s bold mr-s">
                                                BACK
                                            </button>
                                            <button onClick={() => handleSubmit(selectedIccid)} disabled={!selectedIccid} id="esim-assign-confirmation-button" className="pd-s bold">
                                                ASSIGN
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>) : (<>
                    <PlansTable setSelectedPlan={setSelectedPlan} setShowConfirmation={setShowConfirmation} />
                    <div className='two-columns-expand-one'>
                        <div />
                        <button onClick={() => setDisplayAssignEsimForm(false)} id='esim-assign-confirmation-button' className='pd-s bold mr-m'>CANCEL</button>
                    </div>
                </>
            )
        }
    </div>
}
